import React from "react";
import { ProfileHeaderCardComponent } from "../../../services/types/ComponentTypes";
import { ComponentRenderer } from "../../ComponentRenderer";
import { hrmProfileStyles } from "../../../pages/hrmStyles";
import { useDarkMode } from "../../../contexts/DarkModeContext";

interface ProfileHeaderCardProps {
    component: ProfileHeaderCardComponent;
    formData: any;
    handleFormDataChange: (fieldName: string, value: any) => void;
    handleActionTrigger: (action: any) => void;
}

const ProfileHeaderCard: React.FC<ProfileHeaderCardProps> = ({
    component,
    formData,
    handleFormDataChange,
    handleActionTrigger,
}) => {
    // Cast style to any to bypass the specific type mismatch with FlexDirection enum vs string
    const containerStyle = { ...component.style, display: "flex", alignItems: "center" } as React.CSSProperties;
    const { isDarkMode } = useDarkMode();
    const wrapStyle: React.CSSProperties = {
        ...(isDarkMode ? hrmProfileStyles.headerWrapDark : hrmProfileStyles.headerWrap),
        ...containerStyle,
        gap: 14,
    };

    return (
        <div style={wrapStyle}>
            {component.fields?.map((field: any, index: number) => {
                if (field.name === "profile_avatar") {
                    const src = formData[field.BindValue] || "";
                    return (
                        <div key={index} style={{ marginRight: 4, flexShrink: 0 }}>
                            <img
                                src={src || "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='144' height='144'%3E%3Crect width='100%25' height='100%25' fill='%23cbd5e1'/%3E%3Ctext x='50%25' y='54%25' font-size='54' text-anchor='middle' fill='%23334155' font-family='Arial'%3E%3F%3C/text%3E%3C/svg%3E"}
                                alt="Profile Avatar"
                                style={{
                                    ...hrmProfileStyles.avatar,
                                }}
                            />
                        </div>
                    );
                }
                return null;
            })}

            <div style={{ flex: 1 }}>
                {component.fields?.map((field: any, index: number) => {
                    if (field.name !== "profile_avatar") {
                        const value = formData[field.BindValue];
                        const style: React.CSSProperties = {
                            color: isDarkMode ? "#f1f5f9" : "#0f172a",
                            marginBottom: 4,
                        };

                        if (field.name === "profile_name") {
                            style.fontSize = 20;
                            style.fontWeight = 700;
                            style.letterSpacing = "-0.01em";
                        } else {
                            style.fontSize = 13;
                            style.opacity = 0.92;
                        }

                        return (
                            <div key={index} style={style}>
                                {value || "-"}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

export default ProfileHeaderCard;
